export default __webpack_public_path__ + "static/mirai-magical-school-winter-festival_20-5e0f87456ef58429148a4ea1962aa5c1.png";